









import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductCategory, ProductItem, SoftwareItem } from '@/types';
import { Badge } from '@/components/Base';

@Component({
  components: {
    Badge,
  },
})
export default class ProductCategoryHeader extends Vue {
  @Prop() public categoryTitle: string;
  @Prop() public category: ProductCategory<ProductItem | SoftwareItem>;

  public showProducts() {
    this.category.items.forEach(item =>
        this.$store.dispatch('fetchProduct', { url: item.productLink, type: this.category.type }));
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategoryMobile/ProductList/ProductListHeader.vue